import consumer from './consumer';

export default {
  subscribe(organizationId, callback) {
    return consumer.subscriptions.create(
      {
        channel: 'OrganizationMembersTableUpdateChannel',
        organization_id: organizationId,
      },
      {
        received(data) {
          callback(data);
        },
      },
    );
  },
};
